import(/* webpackMode: "eager" */ "/home/developer/www/bazz.bet/bzfront/node_modules/@next/third-parties/dist/google/ga.js");
;
import(/* webpackMode: "eager" */ "/home/developer/www/bazz.bet/bzfront/node_modules/@next/third-parties/dist/google/gtm.js");
;
import(/* webpackMode: "eager" */ "/home/developer/www/bazz.bet/bzfront/node_modules/@next/third-parties/dist/ThirdPartyScriptEmbed.js");
;
import(/* webpackMode: "eager" */ "/home/developer/www/bazz.bet/bzfront/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/developer/www/bazz.bet/bzfront/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/home/developer/www/bazz.bet/bzfront/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Noto_Sans\",\"arguments\":[{\"subsets\":[\"latin\",\"cyrillic\"]}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/developer/www/bazz.bet/bzfront/src/components/Preloader/Preloader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/developer/www/bazz.bet/bzfront/src/components/Scripts/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UTMTracker"] */ "/home/developer/www/bazz.bet/bzfront/src/components/Tracker/UTMTracker.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ClientConfigLoader"] */ "/home/developer/www/bazz.bet/bzfront/src/domains/config/components/ClientConfigLoader.tsx");
;
import(/* webpackMode: "eager" */ "/home/developer/www/bazz.bet/bzfront/src/styles/globals.scss");
